<!-- <div class="refer-earn-main">
        <div class="container">
          <p class="earn-money">EARN $500-1000</p>
          <h1>Refer a Restaurant to eatOS</h1>
          <p class="refer-description">Help a local restaurant and get rewarded for growing the Toast community. Please review the <span class="here-details">terms and conditions</span> prior to submitting a 
            referral. If you're an official Toast partner, submit referrals <span class="here-details">here</span>.</p>
            <p class=" d-flex align-items-center justify-content-center gap-3 learn-more">Learn more about how it works <span><i class="fa-solid fa-angle-down"></i></span></p>
        
            <form [formGroup]="referralForm" (ngSubmit)="onSubmit()" class="form-details">
              <h2 class="Restaurant-title">Refer a Restaurant</h2>
              <h3 class="your-info d-flex align-items-center gap-2"><p class="info-number">1</p>Your Info</h3>
              <div class="row g-3">
                <div class="col-md-6">
                  <select
                    id="dropdown"
                    class="form-select"
                    formControlName="dropdown"
                  >
                  <option value="" disabled selected class="placeholder-option">Who Are You</option>
                    <option *ngFor="let name of names" [value]="name">{{ name }}</option>
                  </select>
                  <div *ngIf="referralForm.get('dropdown')?.invalid && referralForm.get('dropdown')?.touched" class="text-danger">
                    Please select your role.
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    id="fullName"
                    type="text"
                    placeholder="Your Full Name"
                    class="form-control"
                    formControlName="fullName"
                  />
                  <div *ngIf="referralForm.get('fullName')?.invalid && referralForm.get('fullName')?.touched" class="text-danger">
                    Please enter your full name.
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    id="email"
                    type="email"
                    placeholder="Your Email"
                    class="form-control"
                    formControlName="email"
                  />
                  <div *ngIf="referralForm.get('email')?.invalid && referralForm.get('email')?.touched" class="text-danger">
                    Valid email is required.
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    id="company"
                    type="text"
                    placeholder="Your Company"
                    class="form-control"
                    formControlName="company"
                  />
                  <div *ngIf="referralForm.get('company')?.invalid && referralForm.get('company')?.touched" class="text-danger">
                    Company name is required.
                  </div>
                </div>
              </div>
              <h3 class="your-info d-flex align-items-center gap-2 mt-3"><p class="info-number">2</p>Referral Info</h3>
              <div class="row g-3">
                <div class="col-md-6">
                  <input
                    id="referralName"
                    type="text"
                    placeholder="Referral First & Last Name"
                    class="form-control"
                    formControlName="referralName"
                  />
                  <div *ngIf="referralForm.get('referralName')?.invalid && referralForm.get('referralName')?.touched" class="text-danger">
                    Referral name is required.
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    id="referralCompany"
                    type="text"
                    placeholder="Referral Company Name"
                    class="form-control"
                    formControlName="referralCompany"
                  />
                  <div *ngIf="referralForm.get('referralCompany')?.invalid && referralForm.get('referralCompany')?.touched" class="text-danger">
                    Referral company is required.
                  </div>
                </div>
                <div class="col-md-6">
                  <input
                    id="referralEmail"
                    type="email"
                    placeholder="Referral Email"
                    class="form-control"
                    formControlName="referralEmail"
                  />
                  <div *ngIf="referralForm.get('referralEmail')?.invalid && referralForm.get('referralEmail')?.touched" class="text-danger">
                    Valid email is required.
                  </div>
                </div>
          
                <div class="col-md-6">
                  <input
                    id="referralPhone"
                    type="text"
                    placeholder="Referral Phone Number"
                    class="form-control"
                    formControlName="referralPhone"
                  />
                  <div *ngIf="referralForm.get('referralPhone')?.invalid && referralForm.get('referralPhone')?.touched" class="text-danger">
                    Phone number must be 10 digits.
                  </div>
                </div>

                <div class="col-md-12">
                 <textarea name="address" id="address" class="form-control"
                 formControlName="address" placeholder="Why Are They A Good Fit For eatOS?"></textarea>
                 <div *ngIf="referralForm.get('address')?.invalid && referralForm.get('address')?.touched" class="text-danger">
                  Comment is required.
                </div>
                </div>
                <div class="col-md-12">
                    <div class="d-flex align-items-center">
                      <input 
                        type="checkbox" 
                        name="checkbox" 
                        id="checkbox" 
                        formControlName="checkbox" 
                        class="me-2"
                      >
                      <label for="checkbox" class="mb-0  checkbox-text">
                        Would this restaurant be interested in eatOS Payroll & Team Management?
                      </label>
                    </div>
                  </div>
              </div>
          
              <div class="mt-4">
                <button type="submit" class="submit-btn" [disabled]="referralForm.invalid">Submit</button>
              </div>
            </form>
          
        </div>
      
  </div> -->



<div class="refer-rewards-main">
  <div>
    <h3 class="mb-0 rewards-title">Refer a friend to eatOS and earn rewards!</h3>
    <p class="rewards-paragraph">Help a local restaurant and get rewarded for expanding the eatOS community. Please
      review the terms and conditions before submitting a referral.
      If you're an official eatOS partner, submit your referrals here.</p>
  </div>

  <div>
    <h5 class="work-title">How it works</h5>
    <div class="p-0">
      <div class="row g-3">
        <div class="col-12 col-sm-6 col-lg-3 work-box-sidebar">
          <div class="work-box-details">
            <img src="../../../assets/images/refer-works/interest-rate.svg" alt="">
            <div class="mt-3">
              <h1 class="friend-title">You Refer a Friend.</h1>
              <p class="friend-paragraph">Share the basic details using the form, and we’ll handle the rest. Don’t
                forget, terms apply to qualify for the reward.</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 work-box-sidebar">
          <div class="work-box-details">
            <img src="../../../assets/images/refer-works/goodwill.svg" alt="">
            <div class="mt-3">
              <h1 class="friend-title">We Connect with your Referral.</h1>
              <p class="friend-paragraph">The eatOS team will contact your referral, offer a demo, and learn about their
                business.</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 work-box-sidebar">
          <div class="work-box-details">
            <img src="../../../assets/images/refer-works/Activate.svg" alt="">
            <div class="mt-3">
              <h1 class="friend-title">Sign Up & Activate License.</h1>
              <p class="friend-paragraph">Welcome to eatOS! Unlock all features by signing up and activating your
                license.</p>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-3 work-box-sidebar">
          <div class="work-box-details">
            <img src="../../../assets/images/refer-works/bonus.svg" alt="">
            <div class="mt-3">
              <h1 class="friend-title">You earn a bonus!</h1>
              <p class="friend-paragraph">Earn {{currency}}500 for referrals after 30 days, or {{currency}}1,000 if you're already an eatOS
                customer.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 

    <div class="mt-5 row">
      <div class=" col-xl-6 col-12 Alexander-details">
        <!-- <h1 class="Alexander-title">
          {{ employeeName }}, refer a friend
        </h1> -->
        <h1 class="Alexander-title">
          Refer a friend
        </h1>
        <p class="Alexander-paragraph">Share your referral code or link and enjoy exclusive benefits.</p>
        <div class="row">
          <div class="col-2 Share-btn d-flex align-items-center justify-content-center ms-2" style="cursor: pointer;" (click)="sendMailPopup()"><img
              src="../../../assets/images/refer-works/msg.svg" alt=""></div>
          <div class="col-2 Share-btn d-flex align-items-center justify-content-center ms-2" style="cursor: pointer;" (click)="sendSmsPopup()"><img
              src="../../../assets/images/refer-works/com.svg" alt=""></div>
          <div class="col-2 Share-btn-dsbl d-flex align-items-center justify-content-center ms-2" title="Coming Soon"><img
              src="../../../assets/images/refer-works/wht.svg" alt=""></div>
          <div class="col-2 Share-btn-dsbl d-flex align-items-center justify-content-center ms-2" title="Coming Soon"><img
              src="../../../assets/images/refer-works/link.svg" alt=""></div>
          <div class="col-2 Share-btn-dsbl d-flex align-items-center justify-content-center ms-2" title="Coming Soon"><img
              src="../../../assets/images/refer-works/scan.svg" alt="" ></div>
        </div>
        <p class="Unique-code">Your Unique Referral Code</p>
        <button class="Alexander-btn">{{referralCode}}</button>
        <!-- <div class="share-link">
          <h1 class="link-title">Share Referral link:</h1>
          <div class="Copyimg d-flex align-items-center justify-content-between">
            <a href="" class="all-link text-decoration-underline ">https://dashboard.eatos.com</a>
            <button class="copy-link-btn d-flex align-items-center justify-content-between">Copy Link <img
                src="../../../assets/images/refer-works/copy.svg" alt=""></button>
          </div>
        </div> -->
        <!-- <div class="share-link">
          <h1 class="link-title">Share Referral link:</h1>
          <div class="Copyimg d-flex align-items-center justify-content-between">
            <span class="all-link text-decoration-underline">{{ referralLink }}</span>
            <button (click)="copyLink()" class="copy-link-btn d-flex align-items-center justify-content-between">
              Copy Link
              <img src="../../../assets/images/refer-works/copy.svg" alt="">
            </button>
          </div>
        </div> -->
        <div class="share-link">
          <h1 class="link-title">Share Referral link:</h1>
          <div class="Copyimg d-flex align-items-center justify-content-between ">
            <a [href]="referralLink" class="all-link text-decoration-underline" target="_blank">
              {{ referralLink }}
            </a>
              <!-- <span class="all-link text-decoration-underline">{{ referralLink }}</span> -->
              <button (click)="copyLink()" class="copy-link-btn d-flex align-items-center justify-content-between">
                  Copy Link
                  <img src="../../../assets/images/refer-works/copy.svg" alt="Copy Icon">
              </button>
          </div>
      </div>
      </div>
      <div class="col-xl-6 col-12 px-0 d-flex align-items-center justify-content-center" style="background-color: #f6f6f6;">
        <div class="Refer-friend">
          <img src="/assets/images/refer-works/gift2.svg" alt="" width="100%" class="Rafer-img">
          
          <p class="Refer-earn mb-0">Refer a friend and earn {{currency}}500-{{currency}}1000</p>
          
        </div>
      </div>
    </div>

</div>
<ng-template #referEmail let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Enter Mail to Refer' | translate | async }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click');clearMailForm();"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="referralForm" (keydown.enter)="$event.preventDefault()" autocomplete="off">
      <div formGroupName="referralMail">
        <div class="mb-3 row align-items-center">
          <label for="mailId" class="col-sm-5 col-form-label">
            {{ 'Enter Mail*' | translate | async }}
          </label>
          <div class="col-sm-7">
            <input type="text" class="form-control" id="mailId" formControlName="mailId" placeholder="Enter Mail">
            <div class="form-text text-danger" *ngIf="isControlInvalid('referralMail.mailId')">
              {{ 'Please provide a valid email address' | translate | async }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click');clearMailForm();"> {{ 'Cancel' | translate | async }} </button>
        <button (click)="sendMail(); modal.dismiss('cancel click')" class="btn btn-secondary custom-btn" [disabled]="!referralForm.get('referralMail').valid">
          {{ 'Send' | translate | async }}
        </button>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #referSms let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ 'Enter Mobile to Refer' | translate | async }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click'); clearSmsForm();"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="referralForm" (keydown.enter)="$event.preventDefault()" autocomplete="off">
      <div formGroupName="referralMobile">
        <div class="mb-3 row align-items-center">
          <label for="storeMobile" class="col-md-5 mt-2 p-2 form-label">
            {{ 'Phone Number*' | translate | async }}
          </label>
          <div class="col-md-6 p-0">
            <ngx-intl-tel-input
              class="text-start" 
              [cssClass]="{ 'form-control': 1 }"
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [enablePlaceholder]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField?.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="true"
              [maxLength]="10"
              [phoneValidation]="true"
              [customPlaceholder]="placeholder"
              [separateDialCode]="separateDialCode"
              name="storeMobile"
              [separateDialCode]="true"
              formControlName="Mobile"
            >
            </ngx-intl-tel-input>
            <div class="form-text text-danger" *ngIf="isControlInvalid('referralMobile.Mobile')">
              {{ 'Please provide a valid phone number.' | translate | async }}
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel click'); clearSmsForm();"> {{ 'Cancel' | translate | async }} </button>
        <button (click)="sendSms(); modal.dismiss('cancel click')" class="btn btn-secondary custom-btn" [disabled]="!referralForm.get('referralMobile').valid">
          {{ 'Send' | translate | async }}
        </button>
      </div>
    </form>
  </div>
</ng-template>